document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.faq-groups .link');
  if (!links.length) return;

  const linkToSection = new Map();
  links.forEach((link) => {
    const section = document.querySelector(link.getAttribute('href'));
    if (section) {
      linkToSection.set(link, section.closest('.faq-group') || section);
    }
  });

  const setActive = (el) => {
    links.forEach((link) => link.classList.remove('active'));
    el && el.classList.add('active');
  };

  const updateByScroll = () => {
    let candidate;
    linkToSection.forEach((section, link) => {
      const rect = section.getBoundingClientRect();
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        if (!candidate || rect.top < candidate.top) {
          candidate = { link, top: rect.top };
        }
      }
    });
    setActive(candidate && candidate.link);
  };

  links.forEach((link) => {
    link.addEventListener('click', () => setActive(link));
  });

  if (window.location.hash) {
    const current = Array.from(links).find(
      (l) => l.getAttribute('href') === window.location.hash
    );
    current && setActive(current);
  } else {
    updateByScroll();
  }

  window.addEventListener('scroll', updateByScroll, { passive: true });
  window.addEventListener('resize', updateByScroll);
});
